<template>
  <div
    v-if="options && options.length"
    class="search-dropdown-contents display-dropdown"
    style="visibility: hidden;"
  >
    <div class="dropdown-title">
      <img
        class="mr-2"
        src="~/static/chart-line.svg"
        width="18"
        height="18"
        alt="chart"
      >
      {{ searchTitle }}
    </div>
    <div
      v-for="(option, index) in formattedOptions"
      :key="index"
      class="search-item"
      :class="{ 'highlight-option': highlightIndex === index }"
      @mousedown="$emit('on-click-option', option)"
    >
      <span>
        {{ option.value }}
        <span v-if="option.category" class="in-category">in {{ option.category }}</span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    highlightIndex: {
      type: Number,
      default: -1,
    },
    originalQuery: {
      type: String,
      default: '',
    },
    query: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      formattedOptions: [],
    };
  },
  computed: {
    isSearching() {
      return this.originalQuery && this.originalQuery.length;
    },
    searchTitle() {
      return this.isSearching ? 'Suggested Searches' : 'Trending Searches';
    },
  },
  watch: {
    options() {
      this.formatOptions();
    },
    originalQuery() {
      this.formatOptions();
    },
  },
  mounted() {
    this.formatOptions();
  },
  methods: {
    dealCategory(attributes) {
      if (attributes?.subcategory && attributes.subcategory?.length > 0) {
        return attributes.subcategory[0];
      }

      return null;
    },
    // Parse options so we don't have to use v-html to style highlight
    formatOptions() {
      const { query, options } = this;
      const length = query && query.length;

      if (!length) {
        this.formattedOptions = options.map((deal) => {
          const option = deal.public_name;
          return {
            slug: deal.slug,
            category: this.dealCategory(deal.attributes),
            value: option,
          };
        });

        return;
      }

      this.formattedOptions = options.map((deal) => {
        const option = deal.public_name;

        return {
          slug: deal.slug,
          category: this.dealCategory(deal.attributes),
          value: option,
        };
      });
    },
  },
};
</script>

<style scoped lang="scss">
  // TODO: Fix linter issues
  /* stylelint-disable */
  .search-dropdown-contents {
    opacity: 0;
    transition: opacity 125ms, z-index 125ms, visibility 125ms;
    position: absolute;
    left: -2px;
    top: 100%;
    background-color: white;
    z-index: -1000;
    border-radius: 0 0 3px 3px;
    border: 1px solid #ccc;
    margin-top: 6px;
    width: calc(100% + 4px);
    visibility: hidden;

    > div {
      padding: 0.5rem 1rem;
      display: block;
      width: 100%;
      color: #212529;
      white-space: nowrap;
      cursor: pointer;
      text-overflow: ellipsis;
      overflow: hidden;

      &.dropdown-title {
        font-family: Barlow, sans-serif;
        font-weight: 600;
        font-size: 14px;
        cursor: default;
      }

      &.search-item {
        transition: all 0.1s linear;
        font-family: Roboto, sans-serif;
        font-weight: 600;

        .in-category {
          font-weight: 400;
          color: #434D59;
          font-size: 12px;
        }

        span.enable-highlight {
          font-weight: 700;

          .highlight-match {
            font-weight: 400;
          }
        }

        &.highlight-option {
          background-color: #e1e1e9;
          border: none;
        }

        &:hover {
          background-color: #e1e1e9;
          border: none;
        }
      }
    }
  }
  /* stylelint-enable */
</style>
